import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../../TablePagination';

import {useContext} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useState} from 'react';
import Spinner from '../../../../components/Spinner';
import ChartComponent from './ChartComponent';
import {getClientesConquistar} from '../../../../pages/requests';

function TableClientes({leadsProspects, leadsClientes, loadingChart}) {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);

    const {isCard, openCards} = useContext(Context);

    const [leads, setLeads] = useState([]);

    const [isMobile, setIsMobile] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);

    const ITEMS_PER_PAGE = 15;

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getClientesConquistar(lang).then(res => {
                if (res.data.success) {
                    setLeads(res.data.leads);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="">
                    <ChartComponent loading={loadingChart} leadsClientes={leadsClientes} leadsProspects={leadsProspects} />
                </div>
                <div>
                    {' '}
                    <div className="rounded-[8px] dark:bg-gray-800 h-full mb-0 px-0 shadow-md ">
                        <div className="flex flex-wrap  items-center px-4 py-2">
                            <div className="relative w-full max-w-full flex-grow flex-1 ">
                                <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('clientesConquistar')}</h3>
                            </div>
                        </div>
                        <div className="block w-full overflow-x-auto">
                            <table className="items-center w-full bg-transparent border-collapse">
                                <thead>
                                    <tr>
                                        <th className="px-4 bg-gray-100 dark:bg-gray-500 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                            {t('representante')}
                                        </th>
                                        <th className="px-4 bg-gray-100 dark:bg-gray-500 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                            {t('ano')}
                                        </th>
                                        <th className="px-4 bg-gray-100 dark:bg-gray-500 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                            {t('objetivo')}
                                        </th>
                                        <th className="px-4 bg-gray-100 dark:bg-gray-500 text-gray-500 dark:text-gray-100 align-middle border border-solid border-gray-200 dark:border-gray-500 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px">
                                            {t('criados')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {leads?.map(dados => {
                                        const porcentagem = dados.objetivo/dados.criados
                                        return (
                                            <tr className="text-gray-700 dark:text-gray-100">
                                                <th className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">{dados.gestor}</th>
                                                <td className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">{dados.ano}</td>
                                                <td className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">{dados.objetivo}</td>
                                                <td className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                    <div className="flex items-center">
                                                        <span className="mr-2">{porcentagem}%</span>
                                                        <div className="relative w-full">
                                                            <div className="overflow-hidden h-2 text-xs flex rounded-[8px] bg-blue-200">
                                                                <div
                                                                    // style="width: 70%"
                                                                    className={`shadow-none w-[${porcentagem}%] flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600`}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TableClientes;
